export function getQueryString(str: string, search?: string) {
    const t = new RegExp('(^|&)' + str + '=([^&]*)(&|$)', 'i');
    const paramStr = decodeURI(search || window.location.search);
    const n = paramStr.substr(1).match(t);
    // eslint-disable-next-line no-useless-escape
    const rgExp = /(\>|\<|\'|\\|\\\\)/ig;

    if (n != null && !rgExp.test(n[2])) {
        return unescape(n[2]);
    }
    return '';
}

// 数组浅比较
export function equar(a: any[], b: any[]) {
    // 判断数组的长度
    if (a.length !== b.length) {
        return false
    } else {
        // 循环遍历数组的值进行比较
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) {
                return false
            }
        }
        return true;
    }
}

export function changeURLSearchArg(url: string, arg: string, arg_val: string) {
    var pattern = arg + '=([^&]*)';
    var replaceText = arg + '=' + arg_val;
    if (url.match(pattern)) {
        var tmp = '/(' + arg + '=)([^&]*)/gi';
        // eslint-disable-next-line no-eval
        tmp = url.replace(eval(tmp), replaceText);
        return tmp;
    } else {
        // eslint-disable-next-line no-useless-escape
        if (url.match('[\?]')) {
            return url + '&' + replaceText;
        } else {
            return url + '?' + replaceText;
        }
    }
}

export function getQuickSmsUrl(smsServerNumber: string, smsCode: string) {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;//判断是否是 android终端
    var isUc = u.indexOf('UCBrowser') > -1;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isIOS && !isUc) {
        return 'sms:' + smsServerNumber + '&body=' + smsCode;
    } else if (isAndroid || isUc) {
        return 'sms:' + smsServerNumber + '?body=' + smsCode;
    }
}

export function transfromMsToHHMM(ms: number) {
    //@ts-ignore
    if (typeof ms !== Number) {
        ms = Number(ms);
    }
    const hour = Math.floor(ms / 3600000);
    const minue = Math.ceil((ms % 3600000) / 60000);
    // const hourStr = hour < 10 ? `0${hour}小时` : `${hour}小时`;
    // const minueStr = minue < 10 ? `0${minue}分` : `${minue}分`;
    const hourStr = `${hour}小时`;
    const minueStr = `${minue}分`;

    return hour ? (hourStr + minueStr) : minueStr;
}

export function transfromMsToDate(ms: number, format?: string) {
    let cusFormat = format || 'YYYY-MM-DD HH:mm';
    const curDate = new Date(ms);
    const year = curDate.getFullYear();
    const month = curDate.getMonth();
    const day = curDate.getDate();
    const hour = curDate.getHours();
    const minue = curDate.getMinutes();
    return cusFormat.replace('YYYY', `${year}`).replace('MM', `${month + 1}`).replace('DD', `${day}`).replace('HH', `${hour}`).replace('mm', `${minue}`);
}

export const formScrollIntoView = (domId: string) => {
    try {
        let el = document.getElementById(domId);
        el && el.scrollIntoView({ block: "center" });
    } catch (e) { }
}

export function isInViewPort(element: Element | undefined | null) {
    if (!element) {
        return;
    }
    const viewWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewHeight = window.innerHeight || document.documentElement.clientHeight;
    const {
        top,
        right,
        bottom,
        left,
    } = element.getBoundingClientRect();

    return (
        top >= 0 &&
        left >= 0 &&
        right <= viewWidth &&
        bottom <= viewHeight
    );
}

export function debounce(fn: any, delay: number) {
    let timer: any = null //借助闭包
    return function () {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(fn, delay) // 简化写法
    }
}

export function isVipMail(uid: string) {
    const curUid = uid || '';
    return (curUid.endsWith('@vip.163.com') || curUid.endsWith('@vip.126.com') || curUid.endsWith('@188.com') || curUid.endsWith('@vip.188.com'));
}

export function getQueryParams(url: string = window.location.search) {
    const result: { [key: string]: any } = {};
    // 获取url上的参数（使用decodeURIComponent对url参数进行解码）
    const search = decodeURIComponent(url);
    const tempArr = search !== "" ? search.substr(1).split("&") : [];

    tempArr.forEach((item) => {
        if (item) {
            // 将参数名和参数值拆分
            const itemArr = item.split("=");
            // 参数名作为key, 参数值为value
            result[itemArr[0]] = itemArr[1];
        }
    });
    return result;
}

export function deepEqual(obj1: any, obj2: any) {
    // 比较两个对象是否相等
    if (obj1 === obj2) {
        return true;
    }

    // 检查两个对象是否为同一类型
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 == null || obj2 == null) {
        return false;
    }

    // 获取两个对象的属性长度
    let keys1 = Object.keys(obj1), keys2 = Object.keys(obj2);

    // 如果属性长度不同，则对象不相等
    if (keys1.length !== keys2.length) {
        return false;
    }

    // 递归比较对象的每个属性
    for (let key of keys1) {
        if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
            return false;
        }
    }

    return true;
}

export function openAndRemoveLink(url: string, target: "_blank" | "_self") {
    // 创建一个a标签
    var a = document.createElement('a');

    // 设置href属性为提供的url
    a.href = url;

    // 设置target属性，如果是_blank则在新标签页打开
    a.target = target || '_self';

    // 将a标签添加到body中，以便可以触发点击事件
    document.body.appendChild(a);

    // 触发a标签的点击事件来打开链接
    a.click();

    // 移除a标签
    document.body.removeChild(a);
}

export function getQueryParam(url: string, param: string) {
    const regex = new RegExp('[?&]' + param + '=([^&#]*)', 'i');
    const match = regex.exec(url);
    return match ? decodeURIComponent(match[1]) : null;
}

/**
 * 对一个账号(可能为邮箱或者手机号)，左右不做处理，中间做掩码
 * @param account 账号，可以是邮箱或者手机号
 * @returns 掩码处理后的账号
 */
export function maskAccount(account: string): string {
    if (!account) return '';
    // 根据字数处理，保留首尾各一个字符
    if (account.length <= 2) {
        return account;
    }
    // 若长度足够，保留左边约一半和右边约一半字符，中间用 *** 替代
    const len = account.length;
    const leftLen = Math.floor(len / 2);
    const rightStart = len - leftLen;
    if (len <= 4) {
        return account.charAt(0) + '***' + account.slice(-1);
    }
    return account.slice(0, leftLen) + '***' + account.slice(rightStart);
}

export function isMobileDev() {
    try {
        // 判断是否有 touch 事件或视口宽度小于 750
        return 'ontouchstart' in window || document.documentElement.clientWidth < 750;
    } catch (e) {
        return false;
    }
}

export function currentPageRedirect() {

    const isPC = !isMobileDev();
    const pathname = window.location.pathname;
    const currentHref = window.location.href;

    // PC端访问H5页面时重定向到PC版本
    if (isPC && pathname.includes("h5.html")) {
        window.location.href = currentHref.replace('h5.html', 'index.html');
        return;
    }

    // 移动端访问PC页面时重定向到H5版本
    if (!isPC && pathname.includes("index.html")) {
        window.location.href = currentHref.replace('index.html', 'h5.html');
        return;
    }

    // 如果当前路径没有特定文件后缀，根据设备类型添加相应的文件后缀
    if (!pathname.includes(".html")) {
        const baseUrl = window.location.origin + pathname;
        const searchParams = window.location.search;
        
        if (isPC) {
            // PC端，跳转到index.html
            window.location.href = baseUrl + '/index.html' + searchParams;
        } else {
            // 移动端，跳转到h5.html
            window.location.href = baseUrl + '/h5.html' + searchParams;
        }
    }
}

/**
 * 用正则表达式提取身份证出生日期并判断是否年满14周岁
 * @param idNumber 身份证号码（15位或18位）
 * @returns 是否年满14周岁（true: 是，false: 否）
 */
export function overFourteenYears(idNumber: string): boolean {

  const birthMatch = idNumber.match(/^(?:\d{6})(\d{6,8})/);
  if (!birthMatch || !birthMatch[1]) return true;

  const birthDateStr = idNumber.length === 15 
    ? `19${birthMatch[1]}`  // 15位: 900307 → 19900307
    : birthMatch[1];        // 18位: 19900307

  const [year, month, day] = [
    parseInt(birthDateStr.substring(0, 4), 10),
    parseInt(birthDateStr.substring(4, 6), 10) - 1, // 月份从0开始
    parseInt(birthDateStr.substring(6, 8), 10)
  ];
  
  const fourteenDate = new Date(year + 14, month, day);
  const currentDate = new Date();

  return currentDate >= fourteenDate;
}

export function scrollIntoView(selector: HTMLElement | string) {
    window.requestAnimationFrame(() => {
        let element: HTMLElement | null = null;
        if (typeof selector === 'string') {
            element = document.querySelector(selector) as HTMLElement;
        }
        if ('scrollBehavior' in document.documentElement.style) {
            element!.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
            element!.scrollIntoView(false);
        }
    });
}